import script from "./AutofillDiagnosisChoices.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutofillDiagnosisChoices.vue?vue&type=script&setup=true&lang=ts"

import "./AutofillDiagnosisChoices.vue?vue&type=style&index=0&id=edf86e38&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-edf86e38"]])

export default __exports__